import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { baseRoute } from "../../Helper";
import { WEB_ROUTES } from "../../constants";
import { login, hideLoader, showLoader } from "../../redux/slices";
import Toast from "../../Hooks/useToast";
import { ACCOUNT_ENUM } from "../../Pages/Account/Route";

const useLoginController = (setPage, loginAs = "admin") => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.auth);

  const handleForgotPasswordClick = () => {
    setPage(ACCOUNT_ENUM.FORGOT_PASSWORD);
  };

  const handleSignIn = async (values) => {
    dispatch(showLoader());
    const portal = loginAs === "agent" ? "agent" : "admin";
    const payload = {
      email: values.email,
      password: values.password,
      device_type: values.device_type ?? "234",
      device_token: values.device_token ?? "android",
      loginAs: portal,
    };

    try {
      const res = await dispatch(login(payload)).unwrap();
      console.log(res, "response login (redux payload)");
      Toast("Login successful", "success");
      navigate(baseRoute(WEB_ROUTES.DASHBOARD));
    } catch (err) {
      console.log(err, "login error");
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Login failed. Please check your credentials.";
      Toast(msg, "error");
    } finally {
      dispatch(hideLoader());
    }
  };

  return {
    values: {
      loading,
    },
    functions: {
      handleSignIn,
      handleForgotPasswordClick,
    },
  };
};

export default useLoginController;
